<template>

	<div class="row" v-if="isLoaded">
		<div class="col-md-12 col-xl-6">

			<div  class="card border-0" >
				<div class="card-header bg-light">
					<h6 class="card-title">User Details</h6>
				</div>
				<div class="card-body">
					<div class="row p-1">
						<div class="col-md-4">
							Name
						</div>
						<div class="col-md-8">
							{{element.firstName}} {{element.lastName}}
							<i class="icon-user-tie text-danger" title="Super Admin" v-if="isSuperAdmin"></i>
							<i class="icon-user text-danger" title="Admin" v-if="isAdmin"></i>
							<i class="icon-lock" v-if="element.private"></i>
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Email
						</div>
						<div class="col-md-8">
							{{element.email}}
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Joined
						</div>
						<div class="col-md-8">
							{{element.joinedAt | momentTZ}}
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Zip
						</div>
						<div class="col-md-8">
							{{element.zip ? element.zip : '-'}}
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Phone
						</div>
						<div class="col-md-8">
							{{element.phone ? element.phone : '-'}}
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Website
						</div>
						<div class="col-md-8">
							{{element.website ? element.website : '-'}}
						</div>
					</div>
					<div class="row p-1">
						<div class="col-md-4">
							Login/Activity
						</div>
						<div class="col-md-8">
							<i class="fas fa-key m-1" v-if="element.loginPassword" style="font-size: 14px;" title="Password Sign In"></i>
							<i class="fab fa-google m-1" v-if="element.loginGoogle" style="font-size: 14px;" title="Google Sign In"></i>
							<i class="fab fa-facebook m-1" v-if="element.loginFacebook"  style="font-size: 16px;" title="Facebook Sign In"></i>
							<i class="fab fa-apple m-1" v-if="element.loginApple"  style="font-size: 18px;" title="Apple Sign In"></i><br />
							Last active at: {{element.lastActiveAt | momentTZ}}<br />
							Last post/save at: {{element.lastPostSaveAt | momentTZ}}<br />
							<div v-if="!element.active" class="text-danger">Registration incomplete</div>
						</div>
					</div>

					<div class="row p-1">
						<div class="col-md-4">
							Recipes
						</div>
						<div class="col-md-8">
							{{element.totalRecipesCount}} Total<br/>
							{{element.recipesCount}} Published<br/>
							{{element.draftRecipesCount}} Draft{{element.draftRecipesCount === 1 ? '' : 's'}}<br />
							{{element.privateRecipesCount}} Private<br />
						</div>
					</div>

					<div class="row p-1">
						<div class="col-md-4">
							Connections
						</div>
						<div class="col-md-8">
							{{element.friendsCount}}
						</div>
					</div>

					<div class="row p-1">
						<div class="col-md-4">
							Receive Promotions
						</div>
						<div class="col-md-8">
							{{element.notifyPromotions ? 'Yes' : 'No'}}
						</div>
					</div>

					<div class="row p-1">
						<div class="col-12">
							<uibutton text="Download User Data" v-on:click="download" :isLoading="isLoading" class="btn-lg">
								<i v-if='!isLoading' class="icon-arrow-right22 ml-3"></i>
								<i v-if='isLoading' class="icon-spinner2 spinner ml-3"></i>
							</uibutton>
						</div>
					</div>

				</div>
			</div>

		</div>

		<!---------------------------------------------------------------
		-
		- COLLECTIONS
		-
		---------------------------------------------------------------->

		<div class="col-md-6">
			<div  class="card border-0" >
				<div class="card-header bg-light">
					<h6 class="card-title">Collections</h6>
				</div>
				<div class="card-body">
					<div class="row p-1" v-for="collection in element.collections">
						<div class="col-md-12">
							{{collection.name}}
						</div>
					</div>
					<div class="row p-1" v-if="!element.collections.length"> - No Collections -</div>
				</div>
			</div>
		</div>


		<!---------------------------------------------------------------
		-
		- CANCEL
		-
		---------------------------------------------------------------->

		<div class="col-12 border-top-dark-alpha p-1">
			<uibutton text="Cancel" v-on:click="cancel" :isLoading="isLoading" class="btn-lg btn-light">
				<i class="icon-arrow-left22 mr-2 pt-1 float-left"></i>
			</uibutton>
		</div>
	</div>

	<div v-else>
		<div style="height: 100px">
			<div class="loader loader-inline no-margin-top"></div>
		</div>
	</div>
</template>
<script>
import { required, email, string } from 'vuelidate/lib/validators'
import  ui  from '@components/ui'

export default {
	name: 'ImageDetails',
	components : {
		'uiformgrouptext' : ui.formgrouptext,
		'uiformgroupWYSIWYG' : ui.formgroupWYSIWYG,
		'uiformgrouptextarea' : ui.formgrouptextarea,		
		'uiformgroupswitch' : ui.formgroupdoubleswitch,
		'uiformgroupselect2' : ui.formgroupselect2,
		'uibutton' : ui.button,
		
	},
	props : {
        element: {
            type: Object,
            default : null
		},
    },
	data() {
		return {
			elementData : null,
		    misc : null,
			errors : {},
			isLoading : false
		}
	},
	watch: {
		element(value){
			if (value !== null ) this.initializeElement();
		},
		misc(){},
		isLoaded(){},
    },
	mounted(){
		this.initialize();
	},
	computed: {
		isLoaded(){
			return this.elementData != null
		},
		isSuperAdmin: function() {
			return this.element.role === 'ROLE_SUPER_ADMIN'
		},
		isAdmin: function() {
			return this.element.role === 'ROLE_ADMIN'
		},
	},
	validations: {
		form: {
  			id: { },
		}
	},
	methods: {
		initialize() {
			this.elementData = this.element;
			this.loadMisc();
        },
        loadMisc : function(){
            this.$store.dispatch('users/misc')
            .then((response) => {
                this.misc = response.data;
            })
        },
        cancel : function(){
        	this.$emit('user:canceled', {page: this.$route.query.backToPage ? this.$route.query.backToPage : 1});
		},
		b64toBlob: function(b64Data, contentType='', sliceSize=512) {
			const byteCharacters = atob(b64Data);
			const byteArrays = [];

			for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				const slice = byteCharacters.slice(offset, offset + sliceSize);

				const byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				const byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}

			const blob = new Blob(byteArrays, {type: contentType});
			return blob;
		},
		download: function() {
			this.isLoading = true;
			this.$store.dispatch('users/download', {id: this.element.id} )
					.then(function (response) {

						let jsonBlob = this.b64toBlob(response.data, 'application/json');
						if (!window.navigator.msSaveOrOpenBlob){
							// BLOB NAVIGATOR
							const url = window.URL.createObjectURL(jsonBlob);
							window.open(url);
						}else{
							// BLOB FOR EXPLORER 11
							//const url = window.navigator.msSaveOrOpenBlob(pdfBlob, 'shipping-label-'  + this.order.id +'.pdf');
						}
						this.isLoading = false;

					}.bind(this))
					.catch( error => {
						this.isLoading = false;
						//this.errors = error.status.errors
					});
		}

	}
}
</script>